import { useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { AiAgentOrderByInput, Query } from '@lgg/isomorphic/types/__generated__/graphql';
import { AI_AGENTS_LIST_FOR_SELECT_QUERY } from 'src/components/pages/ai-agents/analytics/queries';
import { AiAgentsListVariables } from 'src/components/pages/ai-agents/hooks/use-ai-agents-list-query-params';
import { useCurrentInstitution } from 'src/hooks/use-current-institution';
import { useHandleGraphQLError } from 'src/hooks/use-handle-graphql-error';
import { getNodesFromConnection } from 'src/utils/graphql/get-nodes-from-connection';

export const useAiAgentsListForSelect = () => {
  const { id: companyId } = useCurrentInstitution();
  const handleGraphQLError = useHandleGraphQLError();
  const { data, loading, fetchMore } = useQuery<
    Pick<Query, 'aiAgents'>,
    AiAgentsListVariables<AiAgentOrderByInput>
  >(AI_AGENTS_LIST_FOR_SELECT_QUERY, {
    variables: { companyId, first: 100, orderBy: { name: 'ASC' } },
    onError: handleGraphQLError,
  });

  const { hasNextPage, endCursor } = data?.aiAgents.listAIAgents.pageInfo ?? {};

  const loadMore = useCallback(async () => {
    if (!hasNextPage || !endCursor) {
      return;
    }

    await fetchMore({ variables: { after: endCursor } });
  }, [endCursor, fetchMore, hasNextPage]);

  return {
    aiAgents: getNodesFromConnection(data?.aiAgents.listAIAgents),
    loading,
    loadMore,
    hasNextPage,
  };
};
